// extracted by mini-css-extract-plugin
export var readonly = "_cm-1";
export var star = "_cm-0";